/**
 * Runtime configuration loader
 * Loads configuration from window._env_ (set by config.js)
 * Falls back to process.env only if window._env_ is not available
 */

interface RuntimeConfig {
  REACT_APP_BACKEND_URL: string;
  REACT_APP_SAAED_API_BASE_URL: string;
  REACT_APP_SAAED_ESERVICES_PATH: string;
  REACT_APP_SAAED_ADMIN_PATH: string;
  REACT_APP_NOMINATIM_API_URL: string;
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    _env_?: RuntimeConfig;
  }
}

/**
 * Get configuration from window._env_ or fallback to process.env
 */
function getConfig(): RuntimeConfig {
  // Primary: Use window._env_ from config.js
  if (window._env_) {
    console.log('📝 [CONFIG] Loading from config.js (runtime)');
    return window._env_;
  }
  
  // Fallback: Use process.env (build-time .env)
  console.log('📝 [CONFIG] Loading from process.env (build-time)');
  return {
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL || '',
    REACT_APP_SAAED_API_BASE_URL: process.env.REACT_APP_SAAED_API_BASE_URL || '',
    REACT_APP_SAAED_ESERVICES_PATH: process.env.REACT_APP_SAAED_ESERVICES_PATH || '',
    REACT_APP_SAAED_ADMIN_PATH: process.env.REACT_APP_SAAED_ADMIN_PATH || '',
    REACT_APP_NOMINATIM_API_URL: process.env.REACT_APP_NOMINATIM_API_URL || ''
  };
}

// Export the config object
export const config = getConfig();

// Log loaded configuration (without sensitive data)
console.log('✅ [CONFIG] Configuration loaded:', {
  BACKEND_URL: config.REACT_APP_BACKEND_URL ? '✓ Set' : '✗ Missing',
  SAAED_API: config.REACT_APP_SAAED_API_BASE_URL ? '✓ Set' : '✗ Missing',
  NOMINATIM_API: config.REACT_APP_NOMINATIM_API_URL ? '✓ Set' : '✗ Missing'
});

